import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { useOrganization } from '@components/OrganizationBoundary';
import { ContributorsLimitErrorNotificationIcon, CrossIcon } from '@icons';

function PaymentNotAuthorizedAlert({
  fullScreen = false
}: {
  fullScreen?: boolean;
}) {
  const navigate = useNavigate();
  const { currentOrganization } = useOrganization();
  const [isAlertVisible, setIsAlertVisible] = useState<boolean>(false);
  useEffect(() => {
    if (!currentOrganization.entity) return;
    if (!currentOrganization.entity.lockReasons.includes('subscription-unpaid'))
      return;

    setIsAlertVisible(true);
  }, [currentOrganization]);

  if (!isAlertVisible) return null;
  return (
    <div
      className={classNames(
        'alert-container',
        fullScreen && 'alert-container-full-screen'
      )}
    >
      <div className="info">
        <div className="icon">
          <ContributorsLimitErrorNotificationIcon />
        </div>

        <div className="copies">
          <span className="title">Payment not authorized</span>
          <span className="description">
            Please ensure you have a valid credit card on file.
          </span>
        </div>
      </div>
      <div className="actions">
        <Button
          type="primary"
          onClick={() => {
            setIsAlertVisible(false);
            navigate('/admin-settings/billing');
          }}
        >
          Update billing
        </Button>
        <CrossIcon
          style={{ cursor: 'pointer' }}
          onClick={() => setIsAlertVisible(false)}
        />
      </div>
    </div>
  );
}

export default PaymentNotAuthorizedAlert;
